import { Key } from '@platform/shortcuts/utils/keyboard-platform';

// TODO: https://github.com/usepepper/restaurant-app/pull/4270#discussion_r2673928550
// We should consider some type of cascading or inheritance model for shortcut scopes
export enum SalesPortalKeyboardScope {
  CHECKOUT_PANEL = 'CHECKOUT_PANEL',
  GLOBAL = 'GLOBAL',
  LOCATION_PICKER = 'LOCATION_PICKER',
  ORDER_ENTRY_TABLE = 'ORDER_ENTRY_TABLE',
  PRICING_MANAGEMENT = 'PRICING_MANAGEMENT',
  QUICK_ACTION_MENU = 'QUICK_ACTION_MENU',
}

/**
 * Keyboard shortcuts for Sales Portal.
 * Each experience declares its own shortcuts to allow independent evolution
 * of UX per user group (sales reps vs operators).
 */
export enum SalesPortalShortcuts {
  ArrowDown = Key.ArrowDown,
  ArrowUp = Key.ArrowUp,
  OpenRestaurantSelector = 'l',
  PlaceOrder = `${Key.Shift}+${Key.Enter}`,
  Search = 'Slash',
  QuickActions = 'q',
  SwitchBuildReviewMode = `r`,
  SwitchExperience = `${Key.Alt}+e`,
  ToggleCheckout = 'c',
  ToggleConfidentialFields = 'd',
}
